import { render, staticRenderFns } from "./subscriptionDetail.vue?vue&type=template&id=10d6347c&scoped=true&"
import script from "./subscriptionDetail.vue?vue&type=script&lang=js&"
export * from "./subscriptionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6347c",
  null
  
)

export default component.exports